export default {
  title: 'Attached files'
}
